<template>
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46875 1.39031V0H5.53125V1.39031L0.84375 5.13438V16H11.1562V5.13438L6.46875 1.39031ZM6.46875 5.3665C6.46875 5.62416 6.25847 5.83375 6 5.83375C5.7415 5.83375 5.53125 5.62416 5.53125 5.3665C5.53125 5.10884 5.7415 4.89925 6 4.89925C6.25847 4.89922 6.46875 5.10881 6.46875 5.3665ZM10.2188 15.0625H1.78125V5.58541L5.53125 2.59013V4.04225C4.98566 4.23556 4.59375 4.75603 4.59375 5.36647C4.59375 6.14106 5.22456 6.77122 6 6.77122C6.77541 6.77122 7.40625 6.14106 7.40625 5.36647C7.40625 4.75603 7.01434 4.23556 6.46875 4.04225V2.59016L10.2188 5.58544V15.0625Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
